import { createSlice } from "@reduxjs/toolkit";

const initialState = {
	token: undefined,
	refreshToken: undefined,
	isUserRegistered: false,
	id: undefined,
	phoneNumber: undefined,
	firstName: "",
	lastName: "",
	province: null,
	city: null,
	location: null,
	lastCollectedRequest: null,
	membershipType: null,
	shaba: "",
	score: "",
	profileImage: "",
	birthDate: "",
	familyMembersNumber: 0,
	invitationText: "",
	scoreThreshold: 0,
	minAutoPayAmount: 0,
};

export const UserSlice = createSlice({
	name: "user",
	initialState,
	reducers: {
		setToken(state, { payload }) {
			return {
				...state,
				token: payload,
			};
		},

		setMainTokens(state, { payload }) {
			return {
				...state,
				refreshToken: payload.refreshToken,
				token: payload.token,
			};
		},

		setIsUserRegistered(state, { payload }) {
			return {
				...state,
				isUserRegistered: payload,
			};
		},

		setPhoneNumber(state, action) {
			return {
				...state,
				phoneNumber: action.payload,
			};
		},

		setUserDetails(state, action) {
			return {
				...state,
				...action.payload,
			};
		},

		setNewUserScore(state, action) {
			return {
				...state,
				score: action.payload,
			};
		},

		clearUser: () => {
			return initialState;
		},
	},
});

// Actinon creators are generated for each case reducer function
export const {
	clearUser,
	setToken,
	setIsUserRegistered,
	setPhoneNumber,
	setUserDetails,
	setNewUserScore,
	setMainTokens,
} = UserSlice.actions;

export default UserSlice.reducer;
